module.exports = __webpack_public_path__ + "static/media/male-40.5498cc76.png";